module.exports = __webpack_public_path__ + "static/media/logo-compras-manaus.e1d237b2.png";